import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Wrapper } from '@googlemaps/react-wrapper';
import retrieveLatLong from 'lib/retrieveLatLong';
import FormRow from 'components/FormRow';

const Input = props => (
  <FormRow inputType="text" name="city" id="city" required {...props} />
);
function CityInput({ label, placeholder, value, onChange, setLatLong }) {
  const { t } = useTranslation();
  const [fetchTimeout, setFetchTimeout] = useState(useRef());

  const updateLatLong = async ({ target: { value: city } }) => {
    setFetchTimeout(clearTimeout(fetchTimeout));

    setFetchTimeout(
      setTimeout(() => {
        retrieveLatLong(city)
          .then(latLong => setLatLong(latLong))
          .catch(e => console.log(e));
      }, 350)
    );
  };

  return (
    <Wrapper
      apiKey={process.env.GOOGLE_API_KEY}
      libraries={['places']}
      render={() => (
        <Input
          label={label || t('city.label')}
          placeholder={placeholder || t('city.placeholder')}
          value=""
          disabled
          pending
        />
      )}
    >
      <Input
        onChange={e => {
          onChange(e);
          updateLatLong(e);
        }}
        data-cy="city-input"
        label={label || t('city.label')}
        placeholder={placeholder || t('city.placeholder')}
        value={value}
      />
    </Wrapper>
  );
}

CityInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  setLatLong: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

export default CityInput;
